{
  "name": "icare-frontend",
  "version": "1.0.4",
  "packageManager": "yarn@1.22.22",
  "scripts": {
    "start": "cd ./apps/web && yarn start",
    "web": "cd ./apps/web && yarn web",
    "build:web": "cd ./apps/web && yarn build",
    "lint": "scripts/monorepo-lint.sh",
    "postinstall": "patch-package"
  },
  "workspaces": [
    "apps/*",
    "packages/*"
  ],
  "resolutions": {
    "react": "18.3.1",
    "react-native": "0.76.7",
    "react-native-web": "~0.19.13",
    "react-native-reanimated": "~3.16.1",
    "nativewind": "4.1.23",
    "react-server-dom-webpack": "19.2.1"
  },
  "dependencies": {
    "@expo/html-elements": "^0.11.2",
    "@fullcalendar/core": "^6.1.17",
    "@fullcalendar/daygrid": "^6.1.17",
    "@fullcalendar/icalendar": "^6.1.17",
    "@fullcalendar/interaction": "^6.1.17",
    "@fullcalendar/multimonth": "^6.1.17",
    "@fullcalendar/react": "^6.1.17",
    "@fullcalendar/timegrid": "^6.1.17",
    "@gluestack-ui/accordion": "^1.0.14",
    "@gluestack-ui/avatar": "^0.1.18",
    "@gluestack-ui/button": "^1.0.8",
    "@gluestack-ui/checkbox": "^0.1.38",
    "@gluestack-ui/form-control": "^0.1.19",
    "@gluestack-ui/icon": "^0.1.25",
    "@gluestack-ui/input": "^0.1.32",
    "@gluestack-ui/link": "^0.1.27",
    "@gluestack-ui/nativewind-utils": "^1.0.26",
    "@gluestack-ui/overlay": "^0.1.16",
    "@gluestack-ui/spinner": "^0.1.15",
    "@gluestack-ui/switch": "^0.1.29",
    "@gluestack-ui/textarea": "^0.1.24",
    "@gluestack-ui/toast": "^1.0.8",
    "@legendapp/motion": "^2.4.0",
    "@reduxjs/toolkit": "^2.5.1",
    "bcryptjs-react": "^2.4.6",
    "date-fns": "^4.1.0",
    "expo-document-picker": "^13.0.3",
    "ical.js": "^2.1.0",
    "lodash.debounce": "^4.0.8",
    "qs": "^6.14.0",
    "react-hook-form": "^7.54.2",
    "react-native-css-interop": "^0.1.22",
    "react-native-svg": "15.2.0",
    "react-redux": "^9.2.0",
    "react-signature-canvas": "^1.1.0-alpha.2",
    "redux-persist": "^6.0.0",
    "redux-persist-indexeddb-storage": "^1.0.4",
    "redux-persist-transform-encrypt": "^5.1.1"
  },
  "description": "iCare Elderly Home Resident Management",
  "main": "index.js",
  "author": "ghili <gary@threls.com>",
  "license": "MIT",
  "private": true,
  "devDependencies": {
    "@threls/eslint-config": "^1.0.1",
    "@types/react-signature-canvas": "^1.0.7"
  }
}
